<template>
  <v-card>
    <v-card-title class="headline">
      {{standard && standard.id ? 'Edit':'New'}} Standard
    </v-card-title>

    <v-card-text>
      <v-form v-model="formValid" :lazy-validation="true">
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="subject"
              :items="subjects"
              :rules="[v => v !== '' || 'Please choose a subject']"
              label="Subject"
              required
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="grade"
              :items="grades"
              :rules="[v => v !== '' || 'Grade is required']"
              label="Grade"
              required
              item-text="name"
              item-value="value"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field v-model="catCode" label="Category Code" required></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="catName" label="Category Name" required></v-text-field>
          </v-col>
        </v-row>

        <v-text-field v-model="subCategory" label="Sub-Category Name" required></v-text-field>

        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="standardId" label="Standard ID" required></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="standardCode" label="Standard Code" required></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="standardName" label="Standard Name" required></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="unitGroup" label="Unit Group" required></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="unit" label="Unit" required></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="unitPart" label="Unit Part" required></v-text-field>
          </v-col>
        </v-row>

        <v-textarea :rows="1" auto-grow v-model="standardDescription" label="Standard Description"></v-textarea>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="$emit('close-dialog')">Close</v-btn>
      <v-btn color="green darken-1" text @click="saveStandard">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ['subjects', 'grades', 'standard'],
  data() {
    return {
      formValid: false,
      grade: null,
      subject: null,
      catCode: null,
      catName: null,
      subCategory: null,
      unit: null,
      unitGroup: null,
      unitPart: null,
      standardId: null,
      standardCode: null,
      standardName: null,
      standardDescription: null,
    };
  },
  watch: {
    initCategoryName: function() {
      this.catName = this.initCategoryName;
    },
    initSubCategory: function() {
      this.subCategory = this.initSubCategory;
    }
  },
  methods: {
     ...mapActions(["addErrorMessage", "addSuccessMessage"]),
    forceRender() {
      (this.grade = this.initGrade),
        (this.subject = this.initSubject),
        (this.catCode = this.initCategoryCode),
        (this.catName = this.initCategoryName),
        (this.subCategory = this.initSubCategory);
    },
    saveStandard() {
      if (this.formValid) {
        this.postSave().then(result => {
          this.$emit("saved", result.data);
        });
      } else {
        this.addErrorMessage("Invalid Form");
      }
    },
    async postSave() {
      const postData = {
        category_code: this.catCode,
        category_name: this.catName,
        grade: this.grade,
        grade_end: this.grade,
        grade_start: this.grade,
        standard_code: this.standardCode,
        standard_description: this.standardCode,
        standard_id: this.standardId,
        sub_category: this.subCategory,
        subject: this.subject,
        unit: this.unit,
        unit_group: this.unitGroup,
        unit_part: this.unitPart
      };
      return await this.$axios
        .post("ccStandard", postData)
        .catch(resp => (this.addErrorMessage(resp.message)));
    }
  },
  mounted() {
    this.grade = this.standard.grade;
    this.subject = this.standard.subject;
    this.catCode = this.standard.categoryCode;
    this.catName = this.standard.categoryName;
    this.subCategory = this.standard.subCategory;
    this.standardId = this.standard.id;
    this.standardCode = this.standard.standardCode;
    this.standardName = this.standard.standardName;
    this.standardDescription = this.standard.standardDescription;
  }
};
</script>
<style scoped>
</style>